import { render } from "./Hotspot28.vue?vue&type=template&id=8c5aa408&scoped=true&ts=true"
import script from "./Hotspot28.vue?vue&type=script&lang=ts"
export * from "./Hotspot28.vue?vue&type=script&lang=ts"

import "./Hotspot28.vue?vue&type=style&index=0&id=8c5aa408&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c5aa408"]])

export default __exports__